module.exports = __webpack_public_path__ + "static/media/calculusImg.6af2c372.png";